export default async function scrollTo(element: HTMLElement, to: number, duration = 300) {
  return new Promise((resolve) => {
    const start = element.scrollTop
    const diffValue = to - start
    const increment = 20

    let currentTime = 0
    const animateScroll = function () {
      currentTime += increment
      const val = easeInOut(currentTime, start, diffValue, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        return requestAnimationFrame(animateScroll)
      }
      resolve(null)
    }
    requestAnimationFrame(animateScroll)
  })
}

function easeInOut(curTime: number, startValue: number, diffValue: number, duration: number) {
  curTime /= duration / 2
  if (curTime < 1) {
    return (diffValue / 2) * curTime * curTime + startValue
  }
  curTime--
  return (-diffValue / 2) * (curTime * (curTime - 2) - 1) + startValue
}
